import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { useEffect, useState } from 'react'
import LessonStyleViewPopupBody from '../../../components/modal/LessonStyleViewPopupBody'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import { n_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { COLORS } from '../../../modules/vars'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'

const ReviewLessonStyleBody = () => {
  const [response, setResponse] = useState(null)
  const { useLessonsFlow } = useLessonsStack()
  const isWebview = useIsWebview()
  const { t } = useTranslation()
  const router = useAppRouter()
  const lessonId = router.query.lessonId
  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${apis.lessons.setting(lessonId)}`
        const response = await axiosGet(url)
        setResponse(response?.response)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [lessonId])

  if (!response) return null

  return (
    <div className="px-[8px]">
      <LessonStyleViewPopupBody item={response} />
      <div className="">
        <div>
          <DSButton
            type={BUTTON_TYPE.SOLID}
            size={BUTTON_SIZE.SM}
            onClick={() => {
              if (isWebview) {
                router.back()
              } else {
                //fallback
                router.push(urls.student.newPortal.lessons.reviews.home)
              }
            }}
            className="px-[28px] py-[12px]"
          >
            <DSButton.Label customTxtColor={COLORS.WHITE}>{t(n_common.btn_ok)}</DSButton.Label>
          </DSButton>
        </div>
      </div>
    </div>
  )
}

export default ReviewLessonStyleBody
